import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import AISparkleIcon from './AISparkleIcon'

const AILabelContainer = styled(Group)`
  align-items: center;
  gap: ${rem(4)};
`

interface Props {
  label: string
  variant?: 'medium' | 'small' | 'large'
  weight?: 'normal' | 'bold'
}

function AISearchLabel(props: Props) {
  const { label, variant = 'medium', weight = 'bold' } = props

  return (
    <AILabelContainer direction="horizontal" gap={4}>
      <AISparkleIcon />
      <BodyText variant={variant} weight={weight}>
        {label}
      </BodyText>
    </AILabelContainer>
  )
}

export default AISearchLabel
